import ToolbarPopover from "@/appComponents/Navigation/ContextualToolbar/ToolbarPopover/ToolbarPopover";
import { Text, Flex } from "@theorgchartdev/storybook";
import { getHoverTipContent } from "@/Utils/Misc";
import { GetGroupIconByType } from "@/appComponents/Navigation/RightSidebar/Planning/Activity/Activity.utils";
import React from "react";

export const CommentPopover = ({ change }) => {
  return (
    <ToolbarPopover
      icon={"comment"}
      overlayProps={{ sizeProps: { minWidth: 120, maxWidth: 250, minHeight: 50, maxHeight: 300 } }}
      otherPopoverProps={{
        offsetOptions: -2,
        referenceProps: { onClick: e => e.stopPropagation() }
      }}
      key={5}
      iconProps={{
        tooltipProps: getHoverTipContent("See comment"),
        className: "oc-light-icon",
        size: "small"
      }}
      placement={"bottom-end"}
      iconOnly={true}
      className={"oc-change-details-popover"}
    >
      <Flex direction={"column"} gap={"12px"} width={"100%"}>
        <Flex direction={"column"} justifyContent={"space-between"} width={"100%"}>
          <Flex gap={"4px"} alignItems={"center"}>
            {GetGroupIconByType("Comment")}
            <Text modifier={"medium"} size={"small"}>
              {change.fChangeAuthor}
            </Text>
          </Flex>
        </Flex>
        <Text size={"small"} colorModifier={"lightgrey"} modifier={"italic"}>
          {'"' + change.GetChangeComment() + '"'}
        </Text>
      </Flex>
    </ToolbarPopover>
  );
};
